import Navbar from '@/components/header/navbar.tsx';

const Header = ({ onLanguageSelected, navigationData }: {onLanguageSelected?: (isEnglish: string) => void; navigationData?: any}) => {
    const handleLanguageSelectedFromNavbar = (isEnglish: string) => {
        onLanguageSelected?.(isEnglish);
        return isEnglish;
    }
    return (
        <>
        <a href="#start" title="Skip to main content" className="skip-to-content-link" tabIndex={1}  >Skip to content</a>
        <header className="header">
            <Navbar onLanguageSelected={handleLanguageSelectedFromNavbar} navigationData={navigationData} />
            </header>
        </>
    );
};

export default Header;